<template lang="pug">
  v-app
    component(:is="layout")
      router-view
      v-snackbar(
        v-model="showAlert",
        :color="alertMessage.type",
        content-class="d-flex align-center justify-space-between",
        :timeout=5000,
      ) {{ alertMessage.message }}
        v-btn(dark, text, @click="showAlert = false") Close
</template>

<script>
import Default from '@/layouts/Default.vue';

export default {
  name: 'App',
  components: {
    Default,
  },

  data() {
    return {
      showAlert: false,
      alertMessage: {},
    };
  },

  computed: {
    layout() {
      return this.$route.meta.layout || 'Default';
    },
  },

  created() {
    window.$eventHub.$on('showAlert', this.showAlertSnackBar);
  },

  beforeDestroy() {
    window.$eventHub.$off('showAlert');
  },

  methods: {
    showAlertSnackBar(alert) {
      this.alertMessage = alert;
      this.showAlert = true;
    },
  },
};
</script>
